module.exports = __webpack_public_path__ + "static/img/5054_phase_function_Paper_Points.e901acf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5054_phase_function_Paper_Points.png
// module id = 5j1q
// module chunks = 0